/**
 * Original work Copyright (c) 2019 Burst Apps Team
 */

/**
 * Constants for escrow subtypes
 * @module core
 */
export enum TransactionEscrowSubtype {
    EscrowCreation = 0,
    EscrowSigning,
    EscrowResult,
    SubscriptionSubscribe,
    SubscriptionCancel,
    SubscriptionPayment,
}

